import * as Yup from 'yup';
import {
  yupNpnValidator,
  yupPhoneValidator,
  yupZipValidator,
} from 'Admin/utils/formValidators';
import { NPN_STATUS_MAPPINGS } from '../../../components/NpnStatus';

const customNpnValidator = () =>
  yupNpnValidator().test({
    name: 'dynamic npn error',
    test: function(value) {
      let errorMessage = '';

      if (this.parent.serverValidationErrors.nationalProducerNumber) {
        // Display server validation error message
        errorMessage = this.parent.serverValidationErrors
          .nationalProducerNumber[0];
      } else if (
        this.parent.npnStatus === 'invalid' &&
        this.parent.originalNationalProducerNumber === value
      ) {
        // Same invalid value is re-entered
        errorMessage = NPN_STATUS_MAPPINGS['invalid'].message;
      }

      return errorMessage
        ? this.createError({
            message: errorMessage,
            path: 'nationalProducerNumber',
          })
        : true;
    },
  });

export const userValidationSchema = Yup.object({
  suffix: Yup.string(),
  lastName: Yup.string(),
  firstName: Yup.string(),
  nationalProducerNumber: Yup.string().when('roles', {
    is: val => val.includes('agent'),
    then: customNpnValidator().required('NPN Required for Agent role'),
    otherwise: customNpnValidator(),
  }),
  phoneNumber: yupPhoneValidator(),
  address: Yup.object().shape({
    zipCode: yupZipValidator(),
    city: Yup.string(),
    state: Yup.string(),
    lineOne: Yup.string(),
    lineTwo: Yup.string(),
  }),
  email: Yup.string()
    .email('Invalid Email')
    .required('Required')
    .test({
      name: 'server email error',
      test: function() {
        const error = this.parent.serverValidationErrors.email;
        return error
          ? this.createError({
              message: error[0],
              path: 'email',
            })
          : true;
      },
    }),
  roles: Yup.array()
    .of(Yup.string())
    .min(1, 'At least one role must be selected.'),
});
